import { groupByScope } from '../../lib/bin-scope';
import type { OtherBinLocation } from '../../lib/layout-api';

interface Props {
  bins: OtherBinLocation[];
  onOpenBin: (code: string, e?: React.MouseEvent) => void;
}

const MAX_CHIPS = 4;

function BinChips({ bins, onOpenBin, limit }: Props & { limit?: number }) {
  const shown = limit ? bins.slice(0, limit) : bins;
  return (
    <div className="flex flex-wrap items-center gap-1">
      {shown.map(ob => (
        <span key={ob.bin_code}
          onClick={e => onOpenBin(ob.bin_code, e)}
          className={`px-1.5 py-0.5 rounded text-[9px] font-mono bg-surface text-accent cursor-pointer hover:bg-accent-light ${ob.assigned ? 'font-bold' : ''}`}
          title={`${ob.bin_code} (${ob.zone_code})${ob.assigned ? ' — atanmış' : ''}`}>
          {ob.bin_code}
        </span>
      ))}
      {limit && bins.length > limit && (
        <span className="text-[9px] text-tertiary">+{bins.length - limit}</span>
      )}
    </div>
  );
}

/**
 * Bir ürünün diğer stok konumları. Envanter Dışı Bin'ler ve Akış Bin'leri
 * envanter stoğuyla karışmasın diye kendi başlıkları altında listelenir
 * (bkz. ADR-0009); stok gizlenmez.
 */
export function OtherBinsCell({ bins, onOpenBin }: Props) {
  if (bins.length === 0) return <span className="text-[10px] text-tertiary">—</span>;

  const { inventory, sections } = groupByScope(bins);

  return (
    <div className="flex flex-col gap-0.5">
      {/* Envanter listesi uzun olabilir, kısılır; envanter dışı ve akış
          bölümleri seyrek ve teşhis için önemli, tamamı gösterilir. */}
      {inventory.length > 0 && (
        <BinChips bins={inventory} onOpenBin={onOpenBin} limit={MAX_CHIPS} />
      )}
      {sections.map(s => (
        <div key={s.scope} className="flex flex-wrap items-center gap-1">
          <span className="text-[9px] text-tertiary">{s.label}</span>
          <BinChips bins={s.rows} onOpenBin={onOpenBin} />
        </div>
      ))}
    </div>
  );
}
